import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles.css';

const UploadPage = () => {
  const [file, setFile] = useState(null);
  const [customUrl, setCustomUrl] = useState('');
  const [user, setUser] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch user details from localStorage
    const storedUser = {
      id: localStorage.getItem('userId'),
      unique_username: localStorage.getItem('unique_username'),
      docs_count: parseInt(localStorage.getItem('docs_count')) || 0,
      docs_count_max: parseInt(localStorage.getItem('docs_count_max')) || 5, // Default max limit
    };

    if (!storedUser.id || !storedUser.unique_username) {
      navigate('/login'); // Redirect if not logged in
    } else {
      setUser(storedUser);
    }
  }, [navigate]);

  const handleUpload = async () => {
    if (!file || !user) return;

    if (user.docs_count >= user.docs_count_max) {
      setErrorMessage('You have reached the max document limit. Please upgrade for more uploads.');
      alert('You have reached the max document limit. Please upgrade for more uploads.')
      return;
    }

    const formData = new FormData();
    formData.append('pdf', file);
    formData.append('user_id', user.id);
    formData.append('unique_username', user.unique_username);
    formData.append('custom_url', customUrl);

    try {
      const response = await fetch('./backend/upload.php', {
        method: 'POST',
        body: formData,
        credentials: 'include', // Ensure cookies (session) are sent
      });

      const result = await response.json();
      if (result.status === 'success') {
        alert('Upload successful!');
        localStorage.setItem('docs_count', user.docs_count + 1); // Update doc count in localStorage
        window.location.reload(); // Refresh to reflect new doc count
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setErrorMessage('Upload failed. Please try again.');
    }
  };

  return (
    <div className="file-upload-container">
      <h1>Upload Your File</h1>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      
      <input
        type="file"
        id="fileInput"
        accept="application/pdf"
        onChange={(e) => setFile(e.target.files[0])}
        className="file-upload-input"
        //disabled={!user || user.docs_count >= user.docs_count_max}
      />

      <label htmlFor="fileInput" className="file-upload-label">
        {file ? file.name : "Choose File"}
      </label>

      <input
        type="text"
        style={{ width: '90%' }}
        placeholder="Custom URL (optional)"
        value={customUrl}
        onChange={(e) => setCustomUrl(e.target.value)}
        disabled={!user || user.docs_count >= user.docs_count_max}
      />

      <button
        className="upload-button"
        onClick={handleUpload}
         
      >
        Upload
      </button>
    </div>
  );
};

//disabled={!user || user.docs_count >= user.docs_count_max}
export default UploadPage;
